export default "__VITE_ASSET__2x1VDREC__"